import { headers } from './constants';
import axios from 'axios';
import {
    FILTERS_BASE_URL,
    MAIN_STATS_BASE_URL,
    TIMESLICER_END_MONTH_API_URL,
    ZONES_BASE_URL
} from 'constants/api';
import queryString from 'query-string';

export const filtersAPI = {
    fetchZones: () =>
        axios
            .get(`${ZONES_BASE_URL}`, {
                headers
            })
            .then((response) => response.data),
    fetchFilteredValues: (params) =>
        axios
            .get(`${FILTERS_BASE_URL}?${queryString.stringify(params)}`, {
                headers
            })
            .then((response) => response.data),
    fetchMainStats: (params) =>
        axios
            .get(`${MAIN_STATS_BASE_URL}?${queryString.stringify(params)}`, {
                headers
            })
            .then((response) => response.data),
    fetchLatestDataAvailableMonth: () =>
        axios
            .get(TIMESLICER_END_MONTH_API_URL)
            .then((response) => response.data)
};
